var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPowershell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755441315637,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 14009,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M989.06624 131.285333c24.234667 0 39.381333 19.754667 33.792 44.16l-156.117333 681.856c-5.546667 24.405333-29.738667 44.16-53.973334 44.16H34.95424c-24.234667 0-39.381333-19.754667-33.792-44.16L157.279573 175.445333c5.546667-24.405333 29.738667-44.16 53.973334-44.16h777.813333z m-357.333333 398.72c10.709333-16.810667 9.685333-38.613333-3.84-53.034666L389.215573 223.061333c-16.213333-17.28-44.245333-17.365333-62.549333-0.170666-18.304 17.194667-19.968 45.098667-3.754667 62.336l198.912 211.626666v4.693334l-316.586666 229.248c-19.2 13.952-22.741333 41.685333-7.978667 61.994666 14.762667 20.309333 42.282667 25.472 61.44 11.52l351.104-252.117333c11.946667-8.405333 18.688-15.616 21.930667-22.186667z m-119.296 187.690667a39.594667 39.594667 0 0 0-39.850667 39.381333c0 21.76 17.834667 39.381333 39.850667 39.381334h189.141333a39.594667 39.594667 0 0 0 39.850667-39.381334 39.594667 39.594667 0 0 0-39.850667-39.381333H512.436907z",
    "p-id": 14010
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowershell);
export default __webpack_public_path__ + "static/media/powershell.ea0732f2cdf9745d5c9fee47f410c46a.svg";
export { ForwardRef as ReactComponent };